export default __webpack_public_path__ + "static/media/usersCard-sprite.79aa7670.svg";